export const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const nav = navigator as Navigator & {
    userAgentData?: { mobile?: boolean };
    maxTouchPoints?: number;
  };

  if (typeof nav.userAgentData?.mobile === 'boolean') {
    return nav.userAgentData.mobile;
  }

  const userAgent = nav.userAgent || nav.vendor || '';
  const isIOS = /\b(iPad|iPhone|iPod)\b/i.test(userAgent);
  const isAndroid = /\bAndroid\b/i.test(userAgent);
  const isWindowsPhone = /\bIEMobile\b|\bWindows Phone\b/i.test(userAgent);
  const isGenericMobile = /\bMobile\b|\bOpera Mini\b/i.test(userAgent);
  const isTouchMac =
    /\bMacintosh\b/i.test(userAgent) &&
    typeof nav.maxTouchPoints === 'number' &&
    nav.maxTouchPoints > 1;

  return isIOS || isAndroid || isWindowsPhone || isGenericMobile || isTouchMac;
};
